import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import * as Price from '../../../util/Price';
import colors from '../../../styles/colors';

const ListWrapper = styled.ul`
  width: calc(75vw - 20px);
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);
  margin: 0 10px;
  list-style: none;
  padding: 0 15px;
  overflow: auto;
  max-height: 60vh;
  position: relative;
`;

const ListItem = styled.li`
  min-height: 30px;
  border-bottom: 1px solid ${colors.grey5};
  padding: 10px;
  margin-bottom: 5x;
  font-size: 13px;
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  color: ${(props) => (props.onClick ? colors.seaGreen : null)};
`;

const ListKey = styled.div`
  display: flex;
  flex: 1;
  font-weight: 450;
`;

const ListValue = styled.div`
  display: flex;

  padding-left: 10px;
  justify-content: flex-start;
`;

const ContactDetailsModal = ({
  contactData: contact,
  getRefferedContactsClick,
  fetching,
  close,
}) => {
  const refAcceptedClickable = (contact.totalCouponsAcceptedRef > 0 && !fetching) || false;

  const redeemClickable = (contact.totalCouponsRedRef > 0 && !fetching) || false;

  return (
    <ListWrapper>
      {contact && (
        <>
          {/* <ListHeader>{contact.phoneNumber}</ListHeader> */}
          <ListItem>
            <ListKey>
              Phone Number<div>:</div>
            </ListKey>{' '}
            <ListValue> {contact.phoneNumber}</ListValue>
          </ListItem>
          <ListItem>
            <ListKey>
              Client<div>:</div>
            </ListKey>{' '}
            <ListValue> {contact.organizationName}</ListValue>
          </ListItem>
          <ListItem>
            <ListKey>
              Created At<div>:</div>
            </ListKey>{' '}
            <ListValue>
              {moment(contact.createdAt * 1000).format('L')}
            </ListValue>
          </ListItem>
          <ListItem>
            <ListKey>
              Last Imported<div>:</div>
            </ListKey>
            <ListValue>
              {' '}
              {moment(contact.lastImported * 1000).format('L')}
            </ListValue>
          </ListItem>
          <ListItem>
            <ListKey>
              Current Available Balance<div>:</div>
            </ListKey>
            <ListValue>
              {`$${Price.output(contact.currentAvailableBalance, true)}`}
            </ListValue>
          </ListItem>
          <ListItem>
            <ListKey>
              Total Credits Granted<div>:</div>
            </ListKey>
            <ListValue>
              {`$${Price.output(contact.totalCreditGranted, true)}`}
            </ListValue>
          </ListItem>
          <ListItem>
            <ListKey>
              Total Credits Redeemed<div>:</div>
            </ListKey>
            <ListValue>
              {`$${Price.output(contact.totalCreditRedeemed, true)}`}
            </ListValue>
          </ListItem>
          <ListItem>
            <ListKey>
              Total Discount Granted<div>:</div>
            </ListKey>
            <ListValue>{contact.totalCouponsGranted}</ListValue>
          </ListItem>
          <ListItem>
            <ListKey>
              Total Discount Redeemed<div>:</div>
            </ListKey>
            <ListValue>{contact.totalCouponsRedeemed}</ListValue>
          </ListItem>
          <ListItem
            onClick={
              refAcceptedClickable
                ? () => {
                  getRefferedContactsClick({
                    phoneNumber: contact.phoneNumber,
                    couponType: 'accepted',
                    _id: contact._id,
                  });
                  close();
                }
                : null
            }
          >
            <ListKey>
              Total Discount Accepted<div>:</div>
            </ListKey>
            <ListValue>
              {`$${Price.output(contact.totalCouponsAcceptedRef, true)}`}
          </ListValue>
          </ListItem>
          <ListItem>
            <ListKey>
              Total Ref Clicks<div>:</div>
            </ListKey>
            <ListValue>{contact.totalRefClicks}</ListValue>
          </ListItem>
          <ListItem
            onClick={
              redeemClickable
                ? () => {
                  getRefferedContactsClick({
                    phoneNumber: contact.phoneNumber,
                    couponType: 'redeemed',
                    _id: contact._id,
                  });
                  close();
                }
                : null
            }
          >
            <ListKey>Total Ref Discount Redeemed:</ListKey>
            <ListValue>
              {`$${Price.output(contact.totalCouponsRedRef, true)}`}
            </ListValue>
          </ListItem>
          <ListItem>
            <ListKey>
              Total Ref Conversion Rate<div>:</div>
            </ListKey>
            <ListValue>{contact.totalConversionRateRef}%</ListValue>
          </ListItem>
          <ListItem>
            <ListKey>
              Original Source<div>:</div>
            </ListKey>
            <ListValue>{contact.originalSource}</ListValue>
          </ListItem>
          <ListItem>
            <ListKey>
              Opt-In Method<div>:</div>
            </ListKey>
            <ListValue>{contact.optInMethod}</ListValue>
          </ListItem>
          <ListItem>
            <ListKey>
              Last Opt-In<div>:</div>
            </ListKey>
            <ListValue>
              {contact.lastOptIn
                ? moment(contact.lastOptIn * 1000).format('L')
                : ''}
            </ListValue>
          </ListItem>
          <ListItem>
            <ListKey>
              Opt-Out <div>:</div>
            </ListKey>
            <ListValue>
              {contact.optOut ? moment(contact.optOut * 1000).format('L') : ''}
            </ListValue>
          </ListItem>
          <ListItem>
            <ListKey>
              SMS Opt-Out <div>:</div>
            </ListKey>
            <ListValue>
              {contact.smsCampaignOptOut
                ? moment(contact.smsCampaignOptOut * 1000).format('L')
                : ''}
            </ListValue>
          </ListItem>
        </>
      )}
    </ListWrapper>
  );
};

export default ContactDetailsModal;
